import {
  loadUserInfo,
  loadSaleInfo,
  loadOrder,
  loadQrCode,
  loadDkBuyInfo
} from '../common/api'

import {
  LOAD_USER_INFO,
  SALE_UPDATE,
  CREATE_ORDER,
  UPDATE_NOW_TIME,
  LOAD_QR_CODE,
  LOAD_DK_BUY_INFO
} from './mutation-types.js'
import {
  now
} from '../common/utils';

import {
  LAST_END,
  HOST_WEB,
  HOST_BBS
} from './const';
import {
  WZ
} from '../common/globals';

let _timer = null

function timerStart({
  commit
}) {
  // console.log('timerStart');
  if (!_timer) {
    _timer = setInterval(() => {
      const nowTime = now()

      if (nowTime > LAST_END) {
        timerStop()
      } else {
        commit(UPDATE_NOW_TIME, nowTime)
      }
    }, 1000)
  }
}

function timerStop() {
  if (_timer) {
    clearInterval(_timer)
  }
  _timer = null
}

export default {

  // 获取用户信息
  async getUserInfo({
    commit
  }) {
    let res = await loadUserInfo()
    commit(LOAD_USER_INFO, res)
    return res
  },

  // 获取售卖信息
  async getOrderInfo({
    commit
  }) {
    return loadSaleInfo().then(res => {
      // console.log(res);
      commit(SALE_UPDATE, res)
      return res
    }, err => {
      // alert(JSON.stringify(err))
      return err
    })
    // alert(JSON.stringify(res, null, 2))
    // commit(SALE_UPDATE, res)
  },

  // 获取斗K购买信息
  async getDkBuyInfo({
    commit
  }, orderId) {
    const res = await loadDkBuyInfo(orderId)
    const {
      buyInfo
    } = res
    commit(LOAD_DK_BUY_INFO, buyInfo)
    return buyInfo
  },

  // 获取二维码信息
  async getQRCode({
    commit
  }, subId) {
    let res = loadQrCode(subId).then(res => {
      commit(LOAD_QR_CODE, res)
      return res
    }, err => {
      // alert(JSON.stringify(err))
      return err
    })
    // alert(JSON.stringify(res, null, 2))
    // commit(LOAD_QR_CODE, res)
    return res
  },

  // 下单
  async buy({
    commit
  }, goodsId) {
    let res = loadOrder({
      goodsId: goodsId
    }).then(res => {
      commit(CREATE_ORDER, res)
      return res
    }, err => {
      // alert(JSON.stringify(err))
      return err
    })

    return res
  },

  // 跳转
  // go({
  //   state
  // }, url) {

  // },

  // 开始训练
  goKline() {
    location.href = `https://${HOST_WEB}/award/klinev2/?_fr=20181111`
  },
  goDownload() {
    location.href = `https://${HOST_WEB}/download/?_fr=20181111`
  },
  goAddress(ctx, orderId) {
    location.href = `https://${HOST_BBS}/plugin.php?id=wei_shop&mod=myorderview&virtual=0&orderid=${orderId}`
  },
  // 登录
  login() {
    WZ.go('login')
  },
  // 绑定手机号
  bindMobile() {
    WZ.go('login')
  },


  // 计时
  // tick({
  //   commit
  // }){
  //   commit(UPDATE_NOW_TIME)
  // },
  timerStart,
  timerStop
}
